
export default function Footer() {
  return (
    <footer className="bg-emerald-50 py-12">
      <div className="container mx-auto px-6">
        <div className="flex flex-col lg:flex-row justify-between items-center gap-8">
          <div className="flex flex-col items-center lg:items-start">
            <h2 className="text-2xl font-bold text-gray-800 mb-4">AiCH</h2>
            <p className="text-gray-600 text-center lg:text-left max-w-md">
              Leading industrial AI solutions provider in the United States, transforming industries through intelligent automation.
            </p>
          </div>
          
          <div className="flex flex-col items-center lg:items-end gap-4">
            <div className="flex space-x-6">
              <a href="#" className="text-gray-600 hover:text-emerald-600 transition-colors duration-300">
                <i className="ri-linkedin-fill text-2xl"></i>
              </a>
              <a href="#" className="text-gray-600 hover:text-emerald-600 transition-colors duration-300">
                <i className="ri-twitter-fill text-2xl"></i>
              </a>
              <a href="#" className="text-gray-600 hover:text-emerald-600 transition-colors duration-300">
                <i className="ri-facebook-fill text-2xl"></i>
              </a>
            </div>
            <p className="text-gray-500 text-sm text-center lg:text-right">
              © 2025 AiCH. All rights reserved. | 
              <a 
                href="https://readdy.ai/?origin=logo" 
                target="_blank" 
                rel="noopener noreferrer"
                className="ml-1 hover:text-emerald-600 transition-colors duration-300"
              >
                Powered by Readdy
              </a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
